import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const eventTypes = [
  {
    icon: 'ri-building-4-line',
    title: 'Conferências Corporativas',
    description: 'Múltiplas sessões simultâneas no mesmo espaço. Cada grupo ouve seu palestrante via canal dedicado — sem precisar de salas separadas.',
    highlight: 'Até 10 trilhas ao mesmo tempo',
    image: '/img/stib/fone-palco-orador.webp',
  },
  {
    icon: 'ri-graduation-cap-line',
    title: 'Treinamentos & T&D',
    description: 'Treine iniciantes, intermediários e avançados ao mesmo tempo, no mesmo andar. Redução de até 60% no custo de locação de salas.',
    highlight: 'ROI comprovado para o RH',
    image: '/img/stib/fone-treinamento.webp',
  },
  {
    icon: 'ri-global-line',
    title: 'Eventos Multilíngues',
    description: 'Interpretação simultânea via fones, sem cabines de tradução. Canal 1 = português, Canal 2 = inglês, Canal 3 = espanhol.',
    highlight: 'Sem cabine, sem custo extra',
    image: '/img/stib/fone-tecnico-entrega.webp',
  },
  {
    icon: 'ri-hospital-line',
    title: 'Congressos Científicos',
    description: 'Qualidade de áudio cristalina para apresentações técnicas. Ideal para medicina, engenharia, direito e ciências sociais.',
    highlight: 'Alta fidelidade para conteúdo técnico',
    image: '/img/stib/setor-medico.webp',
  },
  {
    icon: 'ri-music-2-line',
    title: 'Festivais & Silent Disco',
    description: 'Festas silenciosas com LEDs coloridos, sem barulho para vizinhos, sem restrições de horário. Vários DJs ao vivo simultâneos.',
    highlight: 'Zero reclamações de ruído',
    image: '/img/stib/festa-silent-disco.webp',
  },
  {
    icon: 'ri-heart-line',
    title: 'Casamentos',
    description: 'Cada convidado ouve a música que prefere. Avós, jovens e crianças na mesma pista — cada um no seu canal favorito.',
    highlight: 'Festa para todos os gostos',
    image: '/img/stib/festa-silent-disco.webp',
  },
];

export default function EventTypesSection() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.05 });

  return (
    <section ref={ref} className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-4 block">
            Aplicações
          </span>
          <h2
            className={`font-heading font-bold text-5xl md:text-6xl text-secondary mb-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            tipos de eventos
          </h2>
          <p
            className={`font-body text-xl text-gray-500 max-w-2xl mx-auto transition-all duration-700 delay-150 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          >
            A palestra silenciosa se adapta a qualquer formato e porte de evento
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {eventTypes.map((event, i) => (
            <article
              key={i}
              className={`group bg-white border border-gray-100 rounded-3xl overflow-hidden hover:border-primary/30 hover:-translate-y-1 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              {/* Image */}
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={event.image}
                  alt={`Palestra silenciosa em ${event.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-7">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary/10">
                    <i className={`${event.icon} text-primary text-xl`} />
                  </div>
                  <h3 className="font-heading font-bold text-xl text-secondary">{event.title}</h3>
                </div>
                <p className="font-body text-sm text-gray-600 leading-relaxed mb-4">{event.description}</p>
                <div className="inline-flex items-center gap-2 bg-primary/8 rounded-full px-4 py-2">
                  <i className="ri-check-line text-primary text-sm" />
                  <span className="font-body text-xs font-semibold text-primary">{event.highlight}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
